// src/index.js

import React from 'react';
import ReactDOM from 'react-dom';
import 'assets/css/App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import SignIn from 'views/auth/signIn';
import AdminLayout from 'layouts/admin';
import { ChakraProvider } from '@chakra-ui/react';
import theme from 'theme/theme';
import { ThemeEditorProvider } from '@hypertheme-editor/chakra-ui';
import AuthProvider, { AuthContext } from 'contexts/AuthContext';
import routes from 'routes';
import Toast from 'components/toast/Toast'

const App = () => {
	const { loggedIn, user } = React.useContext(AuthContext);
  
	return (
		<>
			<Routes>
				<Route path="/login" element={!loggedIn ? <SignIn /> : <Navigate to="/" />} />
				{loggedIn && user ? (
				<Route path="/" element={<AdminLayout />}>
					{routes.map((route) => (
					<Route key={route.path} path={route.path} element={<route.component />} />
					))}
				</Route>
				) : (
				<Route path="*" element={<Navigate to="/login" replace />} />
				)}
			</Routes>
			<Toast.ToastComponent />
	  	</>
	);
  };
ReactDOM.render(
  <ChakraProvider theme={theme}>
    <React.StrictMode>
      <ThemeEditorProvider>
        <AuthProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthProvider>
      </ThemeEditorProvider>
    </React.StrictMode>
  </ChakraProvider>,
  document.getElementById('root')
);
